import policy from './flashbook.json';
/**
 * 플렁슈 에디터 상수
 * 캔버스 크기, 렌더링 설정 등 중앙화된 설정 값
 */

// 캔버스 기본 크기 (픽셀)
export const CANVAS = {
    BASE_WIDTH: policy.canvasWidth,
    BASE_HEIGHT: policy.canvasHeight,
    ASPECT_RATIO: 3 / 4,

    // 렌더링 스케일 (다운로드 시 고해상도)
    RENDER_SCALE: policy.exportScale,

    // 화면 참조 크기 (좌표 변환용)
    SCREEN_REFERENCE_WIDTH: 500,
};

// 이미지 표시 설정
export const IMAGE_DISPLAY = {
    // 개별 플래시 뷰에서 이미지 최대 크기 (캔버스 대비 %)
    MAX_WIDTH_PERCENT: policy.singleWidthRatio,
    MAX_HEIGHT_PERCENT: policy.singleHeightRatio,
};

// 플래시 기본 설정
export const FLASH_DEFAULTS = {
    INFO_SIZE: 14,
    INFO_FONT: 'sans-serif',
    INFO_WEIGHT: '300',
    INFO_POSITION: policy.layout.info_position,
    SCALE: 1,
    ROTATION: 0,
};

// 저장 관련 설정
export const SAVE = {
    DEBOUNCE_DELAY: 1000,
    THUMBNAIL_QUALITY: 0.8,
    STATUS_DISPLAY_DURATION: 2000,
};

// 터치/드래그 설정
export const INTERACTION = {
    MIN_SWIPE_DISTANCE: 50,
    WHEEL_DEBOUNCE: 300,
    WHEEL_THRESHOLD: 30,
    PINCH_SCALE_FACTOR: 0.01,
    ROTATION_SNAP_DEGREES: 90,
};

// 로컬 스토리지 키
export const STORAGE_KEYS = {
    LAST_STYLE: 'flashbook_last_style',
};
